// Third Party
import * as $ from "jquery";

// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";

// Services
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

// Constants
import { STATUS_CODES, SUCCESS_MSG } from "@/app/constants/status-constants";

export default {
    name: "ModalMatingDogChange",
    mixins: [dateMixins, toastMessageMixins],
    props: {
        damDetails: {
            type: Object,
        },
    },
    data() {
        return {
            isAPILoading: false,
            isAPISubmitLoading: false,

            selectedSire: null,
            sireList: [],
        };
    },
    async created() {
        this.matingId = this.$route.query.id;
        this.sireList = await this.getBreederDamAndSireListByGender("Sire");
    },
    beforeDestroy() {
        this.hideModal();
    },
    methods: {
        show(dogDetails) {
            this.selectedSire = dogDetails;
            $(this.$refs.modalMatingDogChange).modal("show");
        },
        hideModal() {
            $(this.$refs.modalMatingDogChange).modal("hide");
        },
        getPrimaryImage(src) {
            return src ? src : require("@/assets/images/product/dog-default-picture-color.png");
        },
        replaceWithImagePlaceholder(event) {
            event.target.src = require("@/assets/images/product/dog-default-picture-color.png");
        },
        async getBreederDamAndSireListByGender(gender) {
            if (!gender) {
                return;
            }

            try {
                this.isAPILoading = true;
                const damSireListResponse = await breedingManagementService.getBreederDamAndSireListByGender(gender);

                if (damSireListResponse.status === STATUS_CODES.SUCCESS) {
                    const { data: listData } = damSireListResponse;

                    // customLabel to be used in the v-select "label" for searching by breedName and dogName combined
                    const formattedData = listData.map((data) => {
                        const { breedName, dogName } = data;

                        if (breedName && dogName) {
                            return { ...data, customLabel: `${breedName} - ${dogName}` };
                        } else {
                            return { ...data, customLabel: `${breedName}` };
                        }
                    });

                    return formattedData;
                } else {
                    const { ERROR_GET_DAM_SIRE_LIST } = this.toastMessages.mating();
                    this.showAPIErrorToast(ERROR_GET_DAM_SIRE_LIST, damSireListResponse);
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPILoading = false;
            }
        },
        async onUpdateMating() {
            if (!this.damDetails) {
                return;
            }

            try {
                this.isAPISubmitLoading = true;

                const matingDetails = {
                    damId: this.damDetails ? this.damDetails.id : null,
                    sireId: this.selectedSire ? this.selectedSire.id : null,
                };

                const response = await breedingManagementService.updateDamAndSireMatingDetails(this.matingId, matingDetails);
                const { SUCCESS_UPDATE_MATING, ERROR_UPDATE_MATING } = this.toastMessages.mating();

                if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_MATING);
                    $(this.$refs.modalMatingDogChange).modal("hide");

                    this.$emit("onChangeSire", this.selectedSire);
                } else {
                    this.showAPIErrorToast(ERROR_UPDATE_MATING, response);
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPISubmitLoading = false;
            }
        },
        hasValidBirthDate(details) {
            if (!details || !details.birthdate) {
                return "Not Specified";
            }
            return this.formatDateWithoutConversion(details.birthdate);
        },
        hasImageUrl(source) {
            if (!source || !source.imageUrl) {
                return require("@/assets/images/_shared/dog-purchase.png");
            }

            return source.imageUrl;
        },
    },
};
